import { z } from 'zod';

import { Voltage } from './Voltage';

export const OpenCircuitVoltage = {
    validator: Voltage.validators.value,
    units: Voltage.units,
};

export type OpenCircuitVoltage = z.infer<typeof OpenCircuitVoltage.validator>;
